<template>
  <div class="orderSearch search">
    <header>
      <form action="/">
        <van-search
          v-model="searchValue"
          placeholder="订单号、收件人、商品名称"
          show-action
          clearable
          maxlength="32"
          @search="search"
          @cancel="cancel"
          v-focus="isShow"
        />
      </form>
    </header>
    <div class="recordLabel">
      <div class="history" v-if="historyList && historyList.length > 0">
        <p>历史记录<img @click="deleteHistory" src="../../assets/images/delete.png"/></p>
        <ul>
          <li v-for="(item, index) in historyList" :key="index" @click="historyClick(item)">{{ item }}</li>
        </ul>
      </div>
    </div>
    <div v-if="!hideIndexFloat && productlist && productlist.length > 0" style="padding: 0.15rem 0.11rem 0;background: #fff">
      <van-list
        v-model="recLoading"
        :finished="recFinished"
        :immediate-check="false"
        @load="onRecLoad"
      >
        <product-list :title="title" :productlist="productlist"></product-list>
      </van-list>
    </div>
  </div>
</template>

<script>
import productList from '../common/productList'
import { isWeixin, fenxiang} from '../../assets/common/js/config'

export default {
  name: 'orderSearch',
  components: {
    productList
  },
  data () {
    return {
      title: '好物精选',
      historyList: [],
      productlist: [],
      recPage: 0,
      recLoading: false,
      recFinished: false,
      list: [],
      isShow: true,
      searchValue: ''
    }
  },
  computed: {
    hideIndexFloat() {
      return this.$route.query.isShowIndex == 0 || this.$route.query.isShowIndex === '0'
    }
  },
  mounted: function () {
    if (isWeixin()) {
      fenxiang({path: 'ordersearch'})
    }
    this.onRecLoad()
    if (localStorage.getItem('order_historylist') !== null && localStorage.getItem('order_historylist') !== undefined && localStorage.getItem('order_historylist') !== '') {
      this.historyList = JSON.parse(localStorage.getItem('order_historylist'))
    }
  },
  methods: {
    onRecLoad: function () {
      if (this.hideIndexFloat || this.recFinished) return
      var that = this
      that.recLoading = true
      that.recPage++
      var url =
        that.$ajax.getRecommendByOrderSearch_URL +
        '?pageno=' +
        that.recPage +
        '&pagesize=' +
        that.pagesize
      that.$customRequestAjax(url).then(res => {
        that.recLoading = false
        if (res.data.code === 200) {
          var list = res.data.itemlist || []
          if (that.recPage === 1) {
            that.productlist = list
          } else {
            that.productlist = that.productlist.concat(list)
          }
          if (list.length < that.pagesize) {
            that.recFinished = true
          }
        } else {
          that.recFinished = true
        }
      })
    },
    cancel: function () {
      this.$router.go(-1)
    },
    search: function () {
      if (this.searchValue !== '') {
        var query = {
          searchval: encodeURIComponent(this.searchValue)
        }
        if (this.$route.query.actgroupid) {
          query.actgroupid = this.$route.query.actgroupid
        }
        if (this.$route.query.isShowIndex == 0 || this.$route.query.isShowIndex == 1) {
          query.isShowIndex = this.$route.query.isShowIndex
        }
        if (this.$route.query.newpersonhide) {
          query.newpersonhide = this.$route.query.newpersonhide
        }
        this.$router.replace({path: '/ordsealist',
          query: query})
      } else {
        this.$toast('请正确输入查询内容')
      }
    },
    deleteHistory: function () {
      localStorage.removeItem('order_historylist')
      this.historyList = []
    },
    historyClick: function (items) {
      this.searchValue = items
      this.search()
    },
    detailsClick: function () {
      this.$router.push('/orderdetails')
    },
    refundClick: function () {
      this.$router.push('/aftertype')
    },
    afterDetailsClick: function () {
      this.$router.push('/afterdetails')
    },
  },
  directives: {
    focus: {
      inserted: function (el) {
        el.children[0].children[0].children[1].children[0].children[0].focus()
      }
    }
  }
}
</script>

<style scoped lang="scss">
  .list ul li p, .list ul li .proFooter, .product {
    display: flex;
    display: -moz-flex;
    display: -ms-flex;
    display: -webkit-flex;
    display: -o-flex;
    justify-content: space-between;
    -moz-justify-content: space-between;
    -ms-justify-content: space-between;
    -webkit-justify-content: space-between;
    -o-justify-content: space-between;
    align-items: center;
    -moz-align-items: center;
    -ms-align-items: center;
    -webkit-align-items: center;
    -o-align-items: center;
  }
  header {
    z-index: 11;
    /*display: flex;*/
    /*display: -ms-flex;*/
    /*display: -moz-flex;*/
    /*display: -webkit-flex;*/
    /*display: -o-flex;*/
    /*align-items: center;*/
    /*-webkit-align-items: center;*/
    /*-ms-align-items: center;*/
    /*-moz-align-items: center;*/
    /*-o-align-items: center;*/
    padding:0 0.11rem 0;
    height: 0.44rem;
    background: #fff;
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    img {
      width: 0.17rem;
      height: 0.17rem;
      position: absolute;
      left: 0.17rem;
    }
    input {
      display: block;
      width: 90%;
      border: 1px solid #FC0324;
      border-radius:0.15rem;
      height: 0.27rem;
      padding-left: 0.32rem;
      font-size: 0.14rem;
      color: #444;
      &::placeholder {
        font-size: 0.13rem;
        color: #999999;
      }
    }
    span {
      font-size: 0.13rem;
      color: #191818;
      display: block;
      width: 10%;
      margin-left: 0.04rem;
    }
  }
  .recordLabel {
    margin-top: 0.4rem;
    margin-bottom: 0.11rem;
    background: #fff;
    padding: 0.17rem 0.11rem 0;
    .history {
      padding-bottom: 0.4rem;
    }
    .history ul{
      display: flex;
      display: -o-flex;
      display: -webkit-flex;
      display: -ms-flex;
      display: -moz-flex;
      flex-wrap: wrap;
      -webkit-flex-wrap: wrap;
      -moz-flex-wrap: wrap;
      -ms-flex-wrap: wrap;
      -o-flex-wrap: wrap;
    }
    li {
      font-size: 0.12rem;
      color: #5E5E5E;
      padding: 0.06rem 0.15rem;
      background: #EEEFF4;
      border-radius: 0.15rem;
      margin-top: 0.08rem;
      margin-right: 0.1rem;
    }
    .history {
      margin-bottom: 0.02rem;
      p {
        display: flex;
        display: -o-flex;
        display: -webkit-flex;
        display: -ms-flex;
        display: -moz-flex;
        justify-content: space-between;
        -webkit-justify-content: space-between;
        -o-justify-content: space-between;
        -ms-justify-content: space-between;
        -moz-justify-content: space-between;
        font-size: 0.12rem;
        color:#979797;
        img{
          width: 0.2rem;
          height: 0.2rem;
        }
      }
    }
  }
  .list {
    padding-top: 0.44rem;
    >ul {
      margin-bottom: 0.11rem;
      >li {
        background: #fff;
        margin: 0.11rem 0.11rem 0;
        padding: 0.15rem 0.15rem 0.2rem;
        >p {
          border-bottom: 1px solid #EFEFEF;
          padding-bottom: 0.1rem;
          span {
            display: block;
            b {
              display: block;
              font-weight: 400;
              color: #444444;
              font-size:0.12rem;
              float: left;
              &:last-of-type {
                margin-left: 0.04rem;
                line-height: 0.19rem;
                float: left;
                img {
                  width: 0.19rem;
                  height: 0.19rem;
                  float: right;
                }
              }
            }
          }
          i {
            font-style: normal;
            color: #292929;
            font-size: 0.12rem;
            display: flex;
            display: -o-flex;
            display: -webkit-flex;
            display: -ms-flex;
            display: -moz-flex;
            align-items: center;
            -o-align-items: center;
            -webkit-align-items: center;
            -ms-align-items: center;
            -moz-align-items: center;
            b{
              border-left: 1px solid #D8D8D8;
              margin-left: 0.06rem;
              padding-left: 0.07rem;
              display: flex;
              display: -o-flex;
              display: -webkit-flex;
              display: -ms-flex;
              display: -moz-flex;
              align-items: center;
              -o-align-items: center;
              -webkit-align-items: center;
              -ms-align-items: center;
              -moz-align-items: center;
              img {
                width:0.12rem;
                height:0.12rem;
              }
            }
          }
        }
        .product {
          margin-top: 0.16rem;
          position: relative;
          .productBox {
            display: flex;
            display: -moz-flex;
            display: -ms-flex;
            display: -webkit-flex;
            display: -o-flex;
            img {
              width: 0.8rem;
              height: 0.8rem;
            }
            .proContent {
              margin-left: 0.07rem;
              margin-top: 0.08rem;
              flex: 1;
              -webkit-flex: 1;
              -moz-flex: 1;
              -ms-flex: 1;
              -o-flex: 1;
              >b {
                font-size:0.13rem;
                font-weight:400;
                color:rgba(41,41,41,1);
                line-height:0.18rem;
                display: block;
                margin-bottom: 0.05rem;
              }
              >p{
                align-items: flex-start;
                -moz-align-items: flex-start;
                -ms-align-items: flex-start;
                -webkit-align-items: flex-start;
                -o-align-items: flex-start;
                >b {
                  font-size:0.11rem;
                  font-weight:400;
                  color:rgba(108,108,108,1);
                  line-height:0.16rem;
                  display: block;
                }
              }
            }
          }
          .totelPrice {
            position: absolute;
            right: 0;
            z-index: 10;
            opacity:0.85;
            height: 0.8rem;
            display: flex;
            display: -webkit-flex;
            display: -o-flex;
            display: -ms-flex;
            display: -moz-flex;
            flex-direction: column;
            -webkit-flex-direction: column;
            -o-flex-direction: column;
            -ms-flex-direction: column;
            -moz-flex-direction: column;
            justify-content: center;
            -webkit-justify-content: center;
            -o-justify-content: center;
            -ms-justify-content: center;
            -moz-justify-content: center;
            .price {
              display: flex;
              display: -webkit-flex;
              display: -o-flex;
              display: -ms-flex;
              display: -moz-flex;
              align-items: flex-end;
              -webkit-align-items: flex-end;
              -o-align-items: flex-end;
              -ms-align-items: flex-end;
              -moz-align-items: flex-end;
              font-size: 0.14rem;
              font-weight:600;
              color:#222222;
              line-height:0.14rem;
              &:before {
                content: '￥';
                font-size:0.10rem;
                font-weight:600;
                line-height: 0.14rem;
              }
              i {
                font-size: 0.11rem;
                font-style: normal;
                line-height: 0.14rem;
              }
            }
            >b {
              color: #908D8D;
              font-size: 0.11rem;
              line-height: 0.16rem;
              display: block;
              font-weight:400;
              text-align: center;
            }
          }
          .bestSellingSwiper {
            padding-right: 0.6rem;
            >ul {
              >li {
                width: 0.8rem;
                position: relative;
                background-color: white;
              }
            }
            &+.totelPrice {
              background:rgba(255,255,255,1);
              box-shadow:-0.2rem 0 0.09rem -0.16rem rgba(156,156,156,0.5);
            }
          }
        }
        .proFooter {
          margin-top: 0.1rem;
          >p {
            font-size:0.1rem;
            font-weight:400;
            color:rgba(252,3,36,1);
            line-height:0.14rem;
          }
          .proBtn {
            display: flex;
            display: -moz-flex;
            display: -ms-flex;
            display: -webkit-flex;
            display: -o-flex;
            .grayBtn {
              min-width:0.7rem;
              height: 0.27rem;
              display: block;
              margin-left: 0.1rem;
              border-radius:0.14rem;
              border:1px solid rgba(96,96,96,1);
              font-size:0.12rem;
              font-weight:400;
              color:rgba(38,38,38,1);
              line-height:0.17rem;
              padding: 0.05rem 0.11rem;
              background: none;
              outline: none;
            }
            .redBtn {
              min-width:0.7rem;
              height: 0.27rem;
              display: block;
              margin-left: 0.1rem;
              border-radius:0.14rem;
              border:1px solid #FC0324;
              font-size:0.12rem;
              font-weight:400;
              color:#FC0324;
              line-height:0.17rem;
              padding: 0.05rem 0.11rem;
              background: none;
              outline: none;
            }
            .grayBackBtn {
              min-width:0.7rem;
              height: 0.27rem;
              display: block;
              margin-left: 0.1rem;
              background:rgba(221,221,221,1);
              border-radius:0.14rem;
              font-size:0.12rem;
              font-weight:400;
              color:rgba(255,252,252,1);
              line-height:0.17rem;
              padding: 0.05rem 0.11rem;
              outline: none;
              border: 1px solid rgba(221,221,221,1);
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/order/orderSearch.vue